import React from "react";
import { Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";

/**
 * Filter bar – only the row inside card head (Search, Filter button, rightContent).
 * Filters row is rendered outside head: use FilterBarFilters in Card body.
 */
function FilterBar({ showFilters, onToggle, searchContent, rightContent }) {
  return (
    <div className="table-filter-bar">
      <div className="table-filter-bar__row">
        <div className="table-filter-bar__search-wrap">
          {searchContent && (
            <div className="table-filter-bar__search">{searchContent}</div>
          )}
        </div>
        {onToggle && (
          <Button
            type={showFilters ? "default" : "default"}
            icon={<FilterOutlined />}
            onClick={onToggle}
            className="table-filter-bar__btn"
          >
            Filter
          </Button>
        )}
        {rightContent && (
          <div className="table-filter-bar__right">{rightContent}</div>
        )}
      </div>
    </div>
  );
}

/**
 * Wrapper for filter controls – use in Card body (outside ant-card-head).
 * Renders a div below the header so filters show outside the card head.
 */
export function FilterBarFilters({ children }) {
  return <div className="table-filter-bar__filters table-filter-bar-outside-head">{children}</div>;
}

export default FilterBar;
